import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from 'components/icon/icon.component';
import styles from './basic.module.scss';

/**
 * Horizontal navigation, replacing a 20rem fixed sidebar that held a brand chip, a single
 * link and a logout button. At one route that sidebar spent about a fifth of the window on
 * navigation, and the licences table - which has nine columns - was the thing paying for
 * it. A top bar costs ~56px of height instead and still has room for several more links.
 */
const NAV_ITEMS = [{ to: '/licenses', labelKey: 'navigation.licenses' }];

const Topbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className={styles.basicLayout__topbar}>
      <span className={styles.basicLayout__brand}>License Manager</span>

      <nav className={styles.basicLayout__nav}>
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={location.pathname.startsWith(item.to) ? styles.active : ''}
          >
            {t(item.labelKey)}
          </Link>
        ))}
      </nav>

      <button
        type="button"
        className={styles.basicLayout__logout}
        onClick={() => navigate('/sign-in')}
      >
        {t('navigation.logOut')}
        <Icon name="LogOut" size={16} />
      </button>
    </header>
  );
};

export default Topbar;
